import React from "react";
import { ReactZoomPanPinchContentRef } from "react-zoom-pan-pinch";
import {
  StyledSeatControlButton,
  StyledSeatControlButtonWrapper
} from "@/components/ui/SeatSelector/_components/SeatSelectorControl/SeatSelectorControl.styled.ts";

const SeatSelectorControl: React.FunctionComponent<
  ReactZoomPanPinchContentRef
> = ({ zoomIn, zoomOut, resetTransform }) => (
  <StyledSeatControlButtonWrapper>
    <StyledSeatControlButton onClick={() => zoomOut()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <rect
          x="0.5"
          y="0.943359"
          width="15"
          height="15"
          rx="2.5"
          stroke="#865CD0"
        />
        <path
          d="M4 8.44336L12 8.44336"
          stroke="#865CD0"
          strokeLinecap="round"
        />
      </svg>
    </StyledSeatControlButton>
    <StyledSeatControlButton onClick={() => zoomIn()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <rect y="0.443359" width="16" height="16" rx="3" fill="#865CD0" />
        <path d="M8 4.44336V12.4434" stroke="white" strokeLinecap="round" />
        <path d="M4 8.44336L12 8.44336" stroke="white" strokeLinecap="round" />
      </svg>
    </StyledSeatControlButton>
    <StyledSeatControlButton onClick={() => resetTransform()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.32 0.472335C8.70071 0.354506 10.0884 0.597341 11.347 1.17705C12.6056 1.75676 13.6921 2.65347 14.5 3.77934V2.19333C14.5 1.99442 14.579 1.80366 14.7197 1.663C14.8603 1.52235 15.0511 1.44333 15.25 1.44333C15.4489 1.44333 15.6397 1.52235 15.7803 1.663C15.921 1.80366 16 1.99442 16 2.19333V6.44334H11.75C11.5511 6.44334 11.3603 6.36432 11.2197 6.22367C11.079 6.08301 11 5.89225 11 5.69334C11 5.49442 11.079 5.30366 11.2197 5.163C11.3603 5.02235 11.5511 4.94334 11.75 4.94334H13.477C12.7931 3.87324 11.8107 3.02692 10.6512 2.50892C9.4917 1.99093 8.20584 1.82394 6.95248 2.0286C5.69912 2.23326 4.53316 2.80059 3.59864 3.66051C2.66412 4.52044 2.00198 5.63528 1.694 6.86733C1.67128 6.96412 1.62955 7.05542 1.57123 7.13593C1.51291 7.21644 1.43917 7.28455 1.35429 7.3363C1.26942 7.38806 1.1751 7.42242 1.07682 7.43739C0.97854 7.45237 0.878265 7.44765 0.781825 7.42353C0.685385 7.3994 0.594703 7.35634 0.515053 7.29686C0.435404 7.23737 0.368375 7.16264 0.317865 7.07702C0.267355 6.99139 0.234371 6.89658 0.220832 6.79809C0.207293 6.69961 0.213469 6.59941 0.239 6.50333C0.643544 4.88576 1.5434 3.43502 2.81279 2.35388C4.08218 1.27275 5.65766 0.615266 7.319 0.473335L7.32 0.472335ZM3.92 15.3243C4.99199 15.9597 6.19758 16.3359 7.44068 16.4229C8.68378 16.5098 9.93001 16.3052 11.08 15.8253C12.23 15.3454 13.252 14.6034 14.0646 13.6586C14.8771 12.7138 15.4577 11.5922 15.76 10.3833C15.805 10.1915 15.7728 9.98971 15.6702 9.8215C15.5676 9.65329 15.403 9.53219 15.2119 9.48437C15.0207 9.43656 14.8185 9.46587 14.6488 9.56597C14.4791 9.66607 14.3556 9.82893 14.305 10.0193C13.9969 11.2511 13.3347 12.3657 12.4002 13.2254C11.4658 14.0851 10.3 14.6523 9.04688 14.8569C7.79373 15.0616 6.50809 14.8947 5.34871 14.3769C4.18933 13.8591 3.20699 13.0131 2.523 11.9433H4.25C4.44891 11.9433 4.63968 11.8643 4.78033 11.7237C4.92098 11.583 5 11.3922 5 11.1933C5 10.9944 4.92098 10.8037 4.78033 10.663C4.63968 10.5224 4.44891 10.4433 4.25 10.4433H0V14.6933C0 14.8922 0.0790176 15.083 0.21967 15.2237C0.360322 15.3643 0.551088 15.4433 0.75 15.4433C0.948912 15.4433 1.13968 15.3643 1.28033 15.2237C1.42098 15.083 1.5 14.8922 1.5 14.6933V13.1073C2.14478 14.0056 2.96879 14.7605 3.92 15.3243Z"
          fill="#865CD0"
        />
      </svg>
    </StyledSeatControlButton>
  </StyledSeatControlButtonWrapper>
);

export default SeatSelectorControl;
